module.exports = __webpack_public_path__ + "static/img/main2_1.9dc061d6.png";